import React from 'react';
import PropTypes from 'prop-types';
import { getCountryCode, formatText } from '@/helpers/utils';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useSelectedProductFromUserWallet } from '@/hooks/memberHooks';

const LoungeAccessProductDescription = ({ locale, product, customMessage }) => {
  const { selectCard, productDisplayNames } = useCommonContent();
  const productTitle = productDisplayNames[product]?.cardCallOutDisplayName;
  const countryCode = getCountryCode(product, locale);
  const urlSpecifiedProductFromUsersWallet = useSelectedProductFromUserWallet(
    product,
    locale
  );
  const cardLastDigits = urlSpecifiedProductFromUsersWallet
    ? urlSpecifiedProductFromUsersWallet.displayAccountNumber
    : '';

  /**
   * Displays the last 5 digits of the card if the user is logged in.
   * Falls back to showing the logout text if the user is not logged in or the flag is disabled.
   */
  const message =
    customMessage ??
    (cardLastDigits ? selectCard?.message_loggedIn : selectCard?.message);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: formatText(message, {
          productTitle,
          countryCode,
          lastDigits: cardLastDigits,
        }),
      }}
    />
  );
};

LoungeAccessProductDescription.propTypes = {
  locale: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired,
  customMessage: PropTypes.string,
};

export default LoungeAccessProductDescription;
